import Service from "./Service";

export default class QuotesService extends Service {

    submitQuote(data) {
        return this.axios.post('/quotes', data ,{
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        });
    }
}
